var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',_vm._b({staticClass:"chip-status nowrap",attrs:{"color":_vm.statusColor,"text-color":_vm.statusColor === '#ddd' ? '#555' : 'white'}},'v-chip',_vm.$attrs,false),[_vm._v("\n  "+_vm._s(_vm.statusFormatted)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }